<label for="CountryName">{{ "Country" | localize }}</label>
<span class="required text-danger">*</span>
<div class="input-group">
    <div class="input-group-prepend w-100">
        <span class="input-group-text border border-right-0" [ngClass]="{ 'border-danger': (countryInput.invalid && formsubmitted && (countryInput.touched || countryInput.dirty)) ||
(countryInput.invalid && countryInput.errors.required && formsubmitted) }">
            <i class="la la-globe" *ngIf="flagselected == ''"></i>
            <i class="{{ flagselected }}" *ngIf="flagselected != ''"></i>
        </span>
        <div class="btn-group w-100 ng-placeholder" id="countrydropdown">
            <ng-select class="w-100 company-profile custom rounded-1 rounded-left-0"
                       name="countryId"
                       [items]="allCountry"
                       #countryInput="ngModel"
                       [(ngModel)]="countryId"
                       [multiple]="false"
                       bindLabel="name"
                       bindValue="id"
                       dropdownPosition="auto"
                       (change)="SelectedCountry($event)"
                       placeholder="{{ 'SelectCountry' | localize }}"
                       required
                       [disabled]="isdisabled"
                       [ngClass]="{ 'is-invalid': (countryInput.invalid && formsubmitted && (countryInput.touched || countryInput.dirty)) ||
        (countryInput.invalid && countryInput.errors.required && formsubmitted) }">
                <ng-template class="text-wrap" ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <i class="margin-right-5 d-inline-block" [ngClass]="item.tld"></i>

                    <span pTooltip="{{item.name}}" [tooltipDisabled]="false" tooltipPosition="bottom" class="text-dark">
                        {{
  item.name | slice:0:20
                        }}{{item.name?.length > 20 ? '...' : '' }}
                    </span>
                </ng-template>
            </ng-select>
        </div>
    </div>
</div>
<div class="d-block text-danger invalid-feedback">
    <span *ngIf="countryInput.invalid && countryInput.errors.required && formsubmitted">{{ "CountryIsRequired" | localize }}</span>
</div>
